<style lang="scss">
.el-card__body:empty {
	display: none;
}
</style>
<style lang="scss" scoped>
@include component(employee-rules) {
	@include part(header) {
		height: 50px;
		@include flex-center;
		@include part(text) {
			margin-left: 20px;
			width: 25%;
		}
	}
	@include part(text) {
		padding: 20px;
		text-align: center;
	}
}
</style>
<template lang="pug">
el-card.employee-rules
	.clearfix(slot='header')
		.employee-rules__header
			el-switch(v-model='active')
			.employee-rules__header__text Sync staff
		loading(v-if='$apollo.loading')
</template>

<script>
import gql from "graphql-tag";
export default {
	data() {
		return {
			active: null
		};
	},

	watch: {
		active() {
			this.$emit("input", {
				active: this.active
			});
		}
	},

	apollo: {
		active: {
			query: gql`
				query Settings($type: SettingsTypeEnum!) {
					Settings(type: $type) {
						id
						employee_active
                    }
                }
			`,
			variables() {
				return {
					type: "organisation"
				}
			},
			update(r) {
				return r.Settings.employee_active;
			}
		}
	}
};
</script>

